function buildLineGradient(id, color) {
    const svg = document.querySelector("#countryMap svg");

    const namespace = "http://www.w3.org/2000/svg";
    const defs = document.createElementNS(namespace, "defs");
    svg.appendChild(defs);

    const pattern = document.createElementNS(namespace, "pattern");
    pattern.setAttribute("id", id);
    pattern.setAttribute("width", "15");
    pattern.setAttribute("height", "15");
    pattern.setAttribute("patternUnits", "userSpaceOnUse");

    const rect1 = document.createElementNS(namespace, "rect");
    rect1.setAttribute("x", "0");
    rect1.setAttribute("y", "0");
    rect1.setAttribute("width", "15");
    rect1.setAttribute("height", "15");
    rect1.setAttribute("fill", color);
    pattern.appendChild(rect1);

    const poly1 = document.createElementNS(namespace, "polygon");
    poly1.setAttribute("points", "0.5,15 0,15 0,14.5 14.5,0 15,0 15,0.5");
    poly1.setAttribute("fill", "#000");
    poly1.style.scale = "100%"
    pattern.appendChild(poly1);

    defs.appendChild(pattern);
}

export default {
    vhigh: () => {
        buildLineGradient("crosshatch-vhigh", "rgb(226, 241, 216)");
    },
    high: () => {
        buildLineGradient("crosshatch-high", "rgb(253, 243, 202)");
    },
    medium: () => {
        buildLineGradient("crosshatch-medium", "rgb(248, 230, 213)");
    },
    low: () => {
        buildLineGradient("crosshatch-low", "rgb(250, 205, 204)");
    }
}